import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorDialog } from "@advosys/component-react";
import { getAuthService, initAuthServiceAsync } from "src/backend/msal/auth-manager";
export const CallbackHandler = () => {
    const [error, setError] = useState(null);
    const { search } = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(search);
    const redirectUrl = params.get("redirectUrl");
    useEffect(() => {
        const handleCallbackAsync = async () => {
            try {
                if (redirectUrl) {
                    navigate(redirectUrl);
                }
                else {
                    const tenantId = localStorage.getItem("tenantId");
                    if (tenantId) {
                        localStorage.removeItem("tenantId");
                        await initAuthServiceAsync(tenantId);
                        const authService = getAuthService();
                        const result = await authService.handleRedirect();
                        if (result?.account) {
                            const redirectUrl = result.state;
                            navigate(redirectUrl ?? "/");
                        }
                        else {
                            setError("No account found after redirect.");
                        }
                    }
                    else {
                        setError("No tenantId found after redirect.");
                    }
                }
            }
            catch (err) {
                console.error("Redirect handling failed:", err);
                setError("Authentication failed.");
            }
        };
        handleCallbackAsync();
    }, [navigate]);
    if (error) {
        return (_jsx(ErrorDialog, { errorText: error, hidden: false, onDismiss: () => setError(null) }));
    }
    return _jsx("div", { children: "Redirecting..." });
};
